<template>
  <div class="main-container">
    <div clas="constrain-width large">
      <div class="style-guide || page-content">
        <header role="heading" class="constrain-width">
          <h1>Style Guide</h1>
          <p>
            A working site style guide built to manage design and code quality
            control.
          </p>
        </header>
        <StyleGuideSection title="Typography">
          <h1>H1 - This is Heading 1</h1>
          <h2>H2 - This is Heading 2</h2>
          <h3>H3 - This is Heading 3</h3>
          <h4>H4 - This is Heading 4</h4>
          <h5>H5 - This is Heading 5</h5>
          <h6>H6 - This is Heading 6</h6>
          <p>
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
            nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat
            volutpat.
          </p>
          <p>
            Ut wisi enim ad minim veniam, quis nostrud{' '}
            <strong>exerci tation ullamcorper suscipit</strong> lobortis nisl ut
            aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in
            hendrerit{' '} <em>in vulputate velit esse molestie </em> consequat,
            vel illum dolore eu feugiat nulla facilisis at vero eros et{' '}
          </p>
          <p>
            accumsan et iusto odio dignissim qui blandit praesent luptatum zzril
            delenit augue duis dolore te feugait nulla facilisi. Nam liber
            temporcum soluta nobis eleifend option congue.
          </p>
          <p>
            Nihil imperdiet doming id{' '}
            <a href="#" title="Link"> quod mazim placerat </a>{' '} facer possim
            assum. Typi non habent claritatem insitam; est usus legentis in iis
            qui facit eorum claritatem. Investigationes demonstraverunt lectores
            legere me lius quod ii legunt saepius. Claritas est etiam processus
            dynamicus
          </p>
          <p>
            qui sequitur mutationem consuetudium lectorum. Mirum est notare quam
            littera gothica, quam nunc putamus parum claram, anteposuerit
            litterarum formas humanitatis per seacula quarta decima et quinta
            decima. Eodem modo typi, qui nunc nobis videntur parum clari, fiant
            sollemnes in futurum.
          </p>
        </StyleGuideSection>

        <StyleGuideSection title="Lists">
          <ul>
            <li>
              Duis autem vel eum{' '}
              <strong>iriure dolor in hendrerit</strong> in vulputate velit esse
              molestie consequat.
            </li>
            <li>
              Vel illum dolore eu <em>feugiat nulla</em> facilisis at vero eros
              et accumsan et iusto odio dignissim qui blandit.
            </li>
            <li>
              Praesent luptatum zzril delenit augue duis dolore te feugait nulla
              facilisi.
            </li>
            <li>
              Nimperdiet doming id quod mazim placerat facer possim assum. Typi
              non habent claritatem insitam; est usus{' '}
              <a href="#">legentis in iis qui facit</a> eorum claritatem.
              Investigationes demonstraverunt lectores legere me lius quod ii
              legunt saepius.
            </li>
          </ul>
          <ol>
            <li>
              Duis autem vel eum{' '}
              <strong>iriure dolor in hendrerit</strong> in vulputate velit esse
              molestie consequat.
            </li>
            <li>
              Vel illum dolore eu <em>feugiat nulla</em> facilisis at vero eros
              et accumsan et iusto odio dignissim qui blandit.
            </li>
            <li>
              Praesent luptatum zzril delenit augue duis dolore te feugait nulla
              facilisi.
            </li>
            <li>
              Nimperdiet doming id quod mazim placerat facer possim assum. Typi
              non habent claritatem insitam; est usus{' '}
              <a href="#">legentis in iis qui facit</a> eorum claritatem.
              Investigationes demonstraverunt lectores legere me lius quod ii
              legunt saepius.
            </li>
          </ol>
          <div class="style-guide-lists">
            <PillList :items="listDataMock.pill" :action="() => null" />
          </div>
          <div class="style-guide-lists">
            <ItemList :items="listDataMock.list" :action="() => null" />
          </div>
        </StyleGuideSection>
        <StyleGuideSection title="Colours">
          <div role="group" class="style-guide-blocks">
            <ColorFade :colors="colors.primary" />
            <ColorFade :colors="colors.primary_alt" />
            <ColorFade :colors="colors.secondary" />
            <ColorFade :colors="colors.text" />
            <ColorFade :colors="colors.success" />
            <ColorFade :colors="colors.med_risk" />
            <ColorFade :colors="colors.high_risk" />
            <ColorFade :colors="colors.background" />
            <div class="style-guide-gradient"></div>
            <ColorFade :colors="colors.skin" />
            <ColorFade :colors="colors.highlight" />
          </div>
        </StyleGuideSection>

        <StyleGuideSection title="Buttons">
          <h4 class="style-guide-sub-heading">Primary</h4>
          <div role="group" class="style-guide-button-group">
            <CustomButton class="button primary large">
              Button (Large)
            </CustomButton>
            <CustomButton class="button primary"> Button </CustomButton>
            <CustomButton variation="primary" icon="plus">
              Button w/ icon
            </CustomButton>
            <CustomButton class="button primary small" href="#">
              Button (Small)
            </CustomButton>
            <CustomButton class="button primary is-disabled">
              Button (disabled)</CustomButton
            >
            <CustomButton class="button primary active">
              Button (active)</CustomButton
            >
          </div>
          <h4 class="style-guide-sub-heading">Outline with Icon</h4>
          <div role="group" class="style-guide-button-group">
            <CustomButton variation="transparent" icon="plus"
              >Button</CustomButton
            >
            <CustomButton
              class="button is-disabled"
              variation="transparent"
              icon="plus"
            >
              Button (disabled)
            </CustomButton>
            <CustomButton
              class="button active"
              variation="transparent"
              icon="plus"
            >
              CustomButton (active)
            </CustomButton>
          </div>
          <h4 class="style-guide-sub-heading">Outline</h4>
          <div role="group" class="style-guide-button-group">
            <CustomButton variation="outline"> Button </CustomButton>
            <CustomButton class="button active" variation="outline">
              Button (active)
            </CustomButton>
            <CustomButton class="button is-disabled" variation="outline">
              Button (disabled)
            </CustomButton>
          </div>
          <h4 class="style-guide-sub-heading">Rounded</h4>
          <div role="group" class="style-guide-button-group">
            <CustomButton variation="rounded"> Button </CustomButton>
            <CustomButton class="button active" variation="rounded">
              Button (active)</CustomButton
            >
            <CustomButton class="button is-disabled" variation="rounded">
              Button (disabled)
            </CustomButton>
          </div>
          <h4 class="style-guide-sub-heading">Text</h4>
          <div role="group" class="style-guide-button-group">
            <CustomButton class="button" variation="no-border" icon="plus">
              Button
            </CustomButton>
            <CustomButton class="button active" variation="no-border">
              Button
            </CustomButton>
            <CustomButton
              class="button is-disabled"
              variation="no-border"
              icon="plus"
              iconPosition="left"
            >
              Button (disabled)
            </CustomButton>
          </div>
        </StyleGuideSection>
        <StyleGuideSection title="Inputs">
          <FieldSelector
            labelText="Country"
            :options="[{}]"
            placeholder="Select Country"
            :value="''"
            :onChange="() => null"
          />
          <FieldInput
            name="empty-input"
            type="text"
            :autoComplete="false"
            labelText=""
            placeholder="Placeholder"
            value=""
            :touched="true"
            :onBlur="() => null"
            :onChange="() => null"
          />
          <FieldInput
            name="input"
            type="text"
            :autoComplete="false"
            labelText="Text field"
            placeholder=""
            value="Input text"
            :touched="false"
            :onBlur="() => null"
            :validator="(value) => value"
            :onChange="() => null"
          />
          <FieldInput
            name="empty-input"
            type="text"
            :autoComplete="false"
            labelText="Text field"
            placeholder=""
            value=""
            :touched="true"
            :onBlur="() => null"
            :validator="() => dataValidator(false, 'Error message')"
            :onChange="() => null"
          />
        </StyleGuideSection>
        <StyleGuideSection title="Snackbars">
          <div class="style-guide-snackbars">
            <div class="style-guide-snackbars-column">
              <SnackbarPrompt variation="success"
                >Success message text here</SnackbarPrompt
              >
              <SnackbarPrompt icon="done" variation="success"
                >Success message text here</SnackbarPrompt
              >
              <SnackbarPrompt icon="warning" variation="warning"
                >Warning message text here</SnackbarPrompt
              >
              <SnackbarPrompt icon="error" variation="error"
                >Error message text here</SnackbarPrompt
              >
              <SnackbarPrompt variation="dark"
                >Error message text here</SnackbarPrompt
              >
              <SnackbarPrompt icon="error" variation="light"
                >Error message text here</SnackbarPrompt
              >
            </div>
            <div class="style-guide-snackbars-column">
              <SnackbarPrompt variation="low-risk"
                >Success message text here</SnackbarPrompt
              >
              <SnackbarPrompt variation="med-risk"
                >Warning message text here</SnackbarPrompt
              >
              <SnackbarPrompt variation="high-risk"
                >Error message text here</SnackbarPrompt
              >
            </div>
          </div>
          <StyleGuideSection title="Errors">
            <div class="style-guide-errors">
              <ErrorDisplay
                type="small"
                title="Something went wrong"
                description="Request failed with status 502"
                ctaText="Ok"
              />
              <ErrorDisplay
                type="small"
                title="Something went wrong"
                description="Request failed with status 502"
                ctaText="Ok"
                icon="error-warning"
              />
              <ErrorDisplay
                type="large"
                title="Something went wrong"
                description="Request failed with status 502"
                icon="error-image"
                ctaText="Refresh"
              /></div
          ></StyleGuideSection>
        </StyleGuideSection>
        <StyleGuideSection title="Selectors">
          <div class="style-guide-select-boxes">
            <SelectBox
              title="$169.99 Annual ($14.10/month)"
              description="First 14 days free"
              summary="+ Free VR headset"
              :onClick="() => null"
              tag="Website Special"
            /><SelectBox
              highlightText="PROMO"
              title="$169.99 Annual ($14.10/month)"
              description="First 14 days free"
              summary="+ Free VR headset"
              :onClick="() => null"
            />
          </div>
        </StyleGuideSection>
        <StyleGuideSection title="Icons">
          <div class="style-guide-icons">
            <CustomIcon
              className="icon"
              v-for="(item, index) in requireIconDirectory()"
              :key="`${index}-${item}`"
              :title="item"
              :name="item"
            />
          </div>
        </StyleGuideSection>
        <StyleGuideSection title="Emojis">
          <div class="style-guide-icons || emojis">
            <CustomIcon
              className="icon"
              v-for="(item, index) in requireEmojiDirectory()"
              :key="`${index}-${item}`"
              :title="item"
              :name="`emojis/${item}`"
            />
          </div>
        </StyleGuideSection>
        <StyleGuideSection title="Illustrations">
          <div class="style-guide-icons || illustrations">
            <CustomIcon
              className="icon"
              v-for="(item, index) in requireIllustrationDirectory()"
              :key="`${index}-${item}`"
              :title="item"
              :name="`illustrations/${item}`"
            />
          </div>
        </StyleGuideSection>
        <StyleGuideSection title="Programs">
          <div class="style-guide-icons || programs">
            <CustomIcon
              className="icon"
              v-for="(item, index) in requireProgramsDirectory()"
              :key="`${index}-${item}`"
              :title="item"
              :name="`programs/${item}`"
            />
          </div>
        </StyleGuideSection>
        <StyleGuideSection title="Loading">
          <div class="style-guide-loaders">
            <LoadingIndicator size="x-large" icon="illustrations/brain-red" />
            <LoadingIndicator size="large" icon="illustrations/brain-orange" />
            <LoadingIndicator size="small" icon="illustrations/brain-circle" />
          </div>
        </StyleGuideSection>
        <StyleGuideSection title="Modules">
          <div class="style-guide-icons || modules">
            <CustomIcon
              className="icon"
              v-for="(item, index) in requireModulesDirectory()"
              :key="`${index}-${item}`"
              :title="item"
              :name="`modules/${item}`"
            /></div
        ></StyleGuideSection>
      </div>
    </div>
  </div>
</template>
<script>
import {
  PRIMARY_COLORS,
  PRIMARY_COLORS_ALT,
  SECONDARY_COLORS,
  TEXT_COLORS,
  SUCCESS_COLORS,
  MED_RISK_COLORS,
  HIGH_RISK_COLORS,
  BACKGROUND_COLORS,
  SKIN_COLORS,
  HIGHLIGHT_COLORS,
} from "@/config";
import { requireFilesFromDirectory, createValidationDataObject } from "@/utils";
import LIST_DATA_MOCK from "./__mocks__/list.json";
import SnackbarPrompt from "../components/SnackbarPrompt.vue";
import ErrorDisplay from "../components/ErrorDisplay.vue";
import LoadingIndicator from "../components/LoadingIndicator.vue";
import FieldInput from "../components/FieldInput.vue";
import CustomButton from "../components/CustomButton.vue";
import StyleGuideSection from "../components/StyleGuideSection.vue";
import ColorFade from "../components/ColorFade.vue";
import CustomIcon from "../components/CustomIcon.vue";
import SelectBox from "../components/SelectBox.vue";
import FieldSelector from "../components/FieldSelector.vue";
import PillList from "../components/PillList.vue";
import ItemList from "../components/ItemList.vue";

export default {
  data() {
    return {
      listDataMock: LIST_DATA_MOCK,
      dataValidator: createValidationDataObject,
      colors: {
        text: TEXT_COLORS,
        success: SUCCESS_COLORS,
        med_risk: MED_RISK_COLORS,
        high_risk: HIGH_RISK_COLORS,
        background: BACKGROUND_COLORS,
        skin: SKIN_COLORS,
        highlight: HIGHLIGHT_COLORS,
        primary: PRIMARY_COLORS,
        primary_alt: PRIMARY_COLORS_ALT,
        secondary: SECONDARY_COLORS,
      },
    };
  },
  components: {
    CustomIcon,
    CustomButton,
    StyleGuideSection,
    ColorFade,
    SnackbarPrompt,
    ErrorDisplay,
    LoadingIndicator,
    FieldInput,
    SelectBox,
    FieldSelector,
    PillList,
    ItemList,
  },
  methods: {
    requireIconDirectory() {
      const files = requireFilesFromDirectory(
        require.context("../assets/icons/", false, /.svg/)
      ).map((fileName) => fileName.replace("./", "").replace(".svg", ""));

      return files;
    },
    requireEmojiDirectory() {
      const files = requireFilesFromDirectory(
        require.context("../assets/icons/emojis/", false, /.svg/)
      ).map((fileName) => fileName.replace("./", "").replace(".svg", ""));

      return files;
    },
    requireIllustrationDirectory() {
      const files = requireFilesFromDirectory(
        require.context("../assets/icons/illustrations/", false, /.svg/)
      ).map((fileName) => fileName.replace("./", "").replace(".svg", ""));

      return files;
    },
    requireModulesDirectory() {
      const files = requireFilesFromDirectory(
        require.context("../assets/icons/modules/", false, /.svg/)
      ).map((fileName) => fileName.replace("./", "").replace(".svg", ""));

      return files;
    },
    requireProgramsDirectory() {
      const files = requireFilesFromDirectory(
        require.context("../assets/icons/programs/", false, /.svg/)
      ).map((fileName) => fileName.replace("./", "").replace(".svg", ""));

      return files;
    },
  },
};
</script>
